import "./commonComponant.css";
import { PageNotFoundImg } from "../../assets/images/images";

const SomethingWentWrong = ({ resetErrorBoundary }) => {
  return (
    <section className="container">
      <div className="page_not_found_main">
        <img src={PageNotFoundImg} alt="page not found" />
        <h3>Something went wrong</h3>
        <br />
        <button onClick={resetErrorBoundary} className="Pagenotfoundbackbtn">
          Try Again
        </button>
      </div>
    </section>
  );
};

export default SomethingWentWrong;
